import { commonConstants } from 'modules/common/constants';

import { messages } from './TrackingCategoriesFormPart.messages';

export const getTrackingStaticItems = (fieldId: string, fieldName: string) => [
    {
        fieldId,
        exactConstraintId: commonConstants.ANY_VALUE_ID,
        exactConstraintValue: messages.doNotFilterValue,
    },
    {
        fieldId,
        exactConstraintId: commonConstants.EMPTY_VALUE_ID,
        exactConstraintValue: messages.unassignedValue,
    },
    {
        fieldId,
        exactConstraintId: commonConstants.NOT_EMPTY_VALUE_ID,
        exactConstraintValue: messages.notEmptyValue({ fieldName }),
    },
];
